export enum uniteFacturationTypes {
    LOADING = "LOADING",
    SELECTED_UNITE_FACTURATION = "SELECTED_UNITE_FACTURATION",
    GET_UNITE_FACTURATION_LIST = "GET_UNITE_FACTURATION_LIST",
}
  
export default uniteFacturationTypes;